import axios from 'axios';
import {getBizDomain} from "../utils/domain";

var qs = require('qs');

var prefix =  location.href.indexOf('https') == '-1' ? 'http' : 'https';
// var host =location.host.search('test') != '-1' ||  location.host.search('localhost') != '-1'? prefix+'://testfaq.dmall.com' : prefix+'://faq.dmall.com';
var host =location.host.search('test') != '-1' ||  location.host.search('localhost') != '-1'? prefix+`://testfaq.${getBizDomain()}` : prefix+`://faq.${getBizDomain()}`;

const api = {
    host,
    searchCode: "/support/app/faqIssueRes/searchIssue",
    searchText: "/support/app/faqIssueRes/issueDetail"
}


const http = axios.create({
    // baseURL: process.env.NODE_ENV == 'development' ? '' : api.host,
    baseURL:  api.host,
    timeout: 20000
});

http.defaults.withCredentials = true;

http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// http.defaults.headers.post['Content-Type'] = 'application/json';

function getSearch(params){
    console.log('===getSearch==', api.host)
    return new Promise(function(resolve, reject){
        http.post(api.searchCode, qs.stringify(params))
            .then(function(res){
                return resolve(res.data);
            })
            .catch(function(error){
                return reject(error);
            })
    })
}

function getSearchText(id){
    console.log('===getSearchText==', api.host)
    return new Promise(function(resolve, reject){
        http.post(api.searchText, qs.stringify({
            gwJsonObject: {userId: userInfo.userInfo.userId},
            req: {labelId: id === -1 ? undefined : id}
        }))
            .then(function(res){
                return resolve(res.data);
            })
            .catch(function(error){
                return reject(error);
            })
    })
}

export default {
    getSearch: getSearch,
    getSearchText: getSearchText
}
